import { render, staticRenderFns } from "./r-quest-page.vue?vue&type=template&id=44497ebd"
import script from "./r-quest-page.vue?vue&type=script&lang=js"
export * from "./r-quest-page.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/mira-merge-config/mira-merge-config/app-config/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('44497ebd')) {
      api.createRecord('44497ebd', component.options)
    } else {
      api.reload('44497ebd', component.options)
    }
    module.hot.accept("./r-quest-page.vue?vue&type=template&id=44497ebd", function () {
      api.rerender('44497ebd', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/modules/redactor/views/quest/r-quest-page.vue"
export default component.exports